import { AbstractControl, ValidationErrors } from '@angular/forms';

export function inputText250Validator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';

  // Verificar si empieza con espacios en blanco o caracteres no permitidos al inicio (excepto diéresis)
  const startsWithInvalidChar = /^[\s.\-'"°_@+()\[\],;]/.test(value);
  
  // Verificar longitud máxima
  const maxLengthValid = value.length <= 250;
  
  // Permitir letras, números, espacios, acentos, diéresis y caracteres especiales permitidos
  const validCharacters = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.\-'"°_@+()\[\],;]*$/.test(value);

  const errors: ValidationErrors = {};
  if (startsWithInvalidChar) errors.startsWithSpace = true;
  if (!maxLengthValid) errors.maxLength = true;
  if (!validCharacters) errors.invalidCharacters = true;

  return Object.keys(errors).length > 0 ? errors : null;
}